import styled from "@emotion/styled";

export const Cabecalho = styled.header`
  background: ${(props) => props.theme.cores.primarias.a};
  padding: ${(props) => props.theme.espacamentos.m};
`;
